/**
 * Project's library of different spaces, gaps, paddings, margins, etc.
 *
 * Please as a default unit use REM since the rem does not lead to a compounding effect.
 * For converting px to rem  {@link https://nekocalc.com/px-to-rem-converter}
 * */
export enum Spaces {
    // Paddings
    DefaultPadding = "0",
    SmallPadding = "0.5rem",
    Padding = "1rem",
    LargePadding = "1.5rem",

    // Margins
    DefaultMargin = "0",
    SmallMargin = "0.5rem",
    Margin = "1rem",
    LargeMargin = "1.5rem",
}
